<script setup>
    import { useMainStore } from '@/stores/store.js';
    import { useRouter, useRoute } from 'vue-router';
    import { PhCheckFat, PhCaretRight } from '@phosphor-icons/vue';

    const store = useMainStore();
    const router = useRouter();
    const route = useRoute();

    const numberOfSteps = store.steps.length - 1;

    const handleStepClick = (stepName, event) => {
        event.preventDefault();
        // We are always/only ever going 'previous' at this point.
        // User can't go forwrds with the top stepper.
        // store.gotoStep(stepName, router, 'previous', 'click');
    };
</script>

<template>
    <nav
        class="bg1-green-500 w-auto content-end"
        aria-label="Progress">
        <ol
            role="list"
            class="mx-auto flex w-full gap-3 sm:max-w-[550px] sm:justify-center sm:gap-0">
            <li
                v-for="(step, key) in store.steps"
                :key="step.name"
                class=""
                :class="[key !== numberOfSteps ? '' : '', 'flex-0 sm:flex-1']">
                <a
                    href="#"
                    @click="handleStepClick(step.name, $event)"
                    class="relative inline-block cursor-default px-[2px] py-[2px] text-[0.65rem] font-medium uppercase tracking-wider text-white sm:block sm:px-4 sm:py-2 sm:pb-6 md:text-[0.8rem]"
                    :class="[
                        step.status === store.statusFlags.CURRENT || step.status === store.statusFlags.COMPLETE ? 'font-bold' : 'text-whitea50',
                        step.status === store.statusFlags.CURRENT ? 'border-b sm:border-0' : '',
                    ]">
                    {{ step.name }}
                    <span
                        class="absolute bottom-0 left-1/2 z-10 hidden h-[15px] w-[15px] -translate-x-1/2 translate-y-1/2 transform items-center justify-center rounded-full sm:flex sm:h-[18px] sm:w-[18px]"
                        :class="[
                            step.status === store.statusFlags.UPCOMING
                                ? 'border-[1.5px] border-dashed border-whitea50 bg-page'
                                : 'border-[1.5px] border-white bg-white',
                            '',
                        ]">
                        <span
                            class="absolute h-2 w-2 rounded-full bg-accent sm:h-2 sm:w-2"
                            aria-hidden="true"
                            v-if="step.status === store.statusFlags.CURRENT" />
                        <PhCheckFat
                            size="10"
                            weight="fill"
                            color=""
                            aria-hidden="true"
                            class="lux-pos-absmiddle h-2 w-2 fill-accent sm:h-2.5 sm:w-2.5"
                            v-if="step.status === store.statusFlags.COMPLETE" />
                    </span>
                    <span
                        :class="[key === numberOfSteps ? 'w-1/2' : '', key === 0 ? 'left-1/2 w-1/2' : '']"
                        class="absolute inset-x-0 bottom-0 z-0 hidden items-center sm:flex"
                        aria-hidden="true">
                        <div class="h-[1px] w-full bg-white" />
                    </span>
                    <PhCaretRight
                        size="10"
                        weight="fill"
                        color=""
                        aria-hidden="true"
                        class="absolute left-auto right-0 top-1/2 h-2 w-2 -translate-y-1/2 translate-x-[10px] fill-white sm:hidden sm:h-2.5 sm:w-2.5"
                        :class="[key === numberOfSteps ? 'hidden' : '', '']" />
                </a>
            </li>
        </ol>
    </nav>
</template>

<style scoped></style>
